.loader {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  min-height: 1rem;
  max-height: 1rem;
  padding: .25rem 0;
}
